import { render, staticRenderFns } from "./PerkembanganSiswa.vue?vue&type=template&id=b18a3df6"
import script from "./PerkembanganSiswa.vue?vue&type=script&lang=js"
export * from "./PerkembanganSiswa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports